module.exports = __webpack_public_path__ + "img/401.c17e17f1.svg";